var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.25H9C8.59 2.25 8.25 2.59 8.25 3C8.25 3.41 8.59 3.75 9 3.75H18C18.69 3.75 19.25 4.31 19.25 5V15C19.25 15.69 18.69 16.25 18 16.25H16.75V9C16.75 7.48 15.52 6.25 14 6.25H6C4.48 6.25 3.25 7.48 3.25 9V19C3.25 20.52 4.48 21.75 6 21.75H14C15.52 21.75 16.75 20.52 16.75 19V17.75H18C19.52 17.75 20.75 16.52 20.75 15V5C20.75 3.48 19.52 2.25 18 2.25ZM15.25 19C15.25 19.69 14.69 20.25 14 20.25H6C5.31 20.25 4.75 19.69 4.75 19V9C4.75 8.31 5.31 7.75 6 7.75H14C14.69 7.75 15.25 8.31 15.25 9V19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.25H10.75V12C10.75 11.59 10.41 11.25 10 11.25C9.59 11.25 9.25 11.59 9.25 12V13.25H8C7.59 13.25 7.25 13.59 7.25 14C7.25 14.41 7.59 14.75 8 14.75H9.25V16C9.25 16.41 9.59 16.75 10 16.75C10.41 16.75 10.75 16.41 10.75 16V14.75H12C12.41 14.75 12.75 14.41 12.75 14C12.75 13.59 12.41 13.25 12 13.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.fbe4afcd285360ee7a804e095b07308c.svg";
export { ForwardRef as ReactComponent };